import React from "react";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Dashboard from "@/pages/Dashboard";
import RecordingDetail from "@/pages/RecordingDetail";
import Timetable from "@/pages/Timetable";
import Groups from "@/pages/Groups";
import GroupDetail from "@/pages/GroupDetail";
import Pricing from "@/pages/Pricing";
import Account from "@/pages/Account";
import Coach from "@/pages/Coach";
import Analytics from "@/pages/Analytics";
import Review from "@/pages/Review";
import Spec from "@/pages/Spec";
import Progress from "@/pages/Progress";
import Teacher from "@/pages/Teacher";
import BillingSuccess from "@/pages/BillingSuccess";
import AppLayout from "@/components/AppLayout";
import "@/App.css";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-neutral-500 text-[0.86rem]">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/recording/:id" element={<RecordingDetail />} />
            <Route path="/timetable" element={<Timetable />} />
            <Route path="/review" element={<Review />} />
            <Route path="/spec" element={<Spec />} />
            <Route path="/progress" element={<Progress />} />
            <Route path="/classes" element={<Teacher />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/groups/:id" element={<GroupDetail />} />
            <Route path="/coach" element={<Coach />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/account" element={<Account />} />
          </Route>
        </Routes>
        <Toaster theme="dark" position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
